import { Fragment } from 'react';

import { Header, Main, Footer } from 'views/coogoong/components';

// ----------------------------------------------------------------------

const CoogoongRootView = () => {
	return (
		<Fragment>
			<Header />
			<Main />
			<Footer />
		</Fragment>
	);
};

export default CoogoongRootView;
